import {GlobalUtility} from '../../../service/global-utility.service';
import axios from 'axios';
import {
  FLOOR,
  FLOOR_ROOMS,
  GET_FLOORS_BY_HOTEL,
} from '../../../service/constants.service';

const state = {
  floor : {},
  floors : [],
  newFloor : {
    price_rate : '',
    hotel_id : '',
    status : '',
  },

};


const mutations = {

  set_floors : (state,params) =>{
    state.floors = params;
  },

  set_floor : (state,param) =>{
    state.floor = param;
  },

  set_new_floor : (state ,params) =>{
    state.floors.push(params);
    state.newFloor = {
      price_rate : '',
      hotel_id : '',
      status : '',
    }
  },

  set_update_floor : (state,param) =>{
    let floor = state.floors.find(floor => floor.id === param.id);
    Object.assign(floor,param);
  },

  set_delete_floor : (state,param) =>{

  },

  set_null_floor : (state , param) =>{
    state.floor = {}
  },

  //
  set_null_floors : (state,param) =>{
    state.floors = [];
  },


  set_floors_by_hotel : (state,param) =>{
    state.floors = param;
  },

};


const actions = {

  //floor
  getFloors(){

  },

  createFloor({commit},param){
    let parameter = GlobalUtility.deCapitalizeProperties(param);
    return axios.post(FLOOR,parameter).then((response)=>{
      commit('set_new_floor',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Create floor record');
      return false;
    })
  },

  async viewFloor({commit},param){
    return await axios.get(`${FLOOR}/${param}`).then((response)=>{
      commit('set_floor',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Floor Details');
      return false;
    });
  },

  updateFloor({commit},params){
    return axios.put(`${FLOOR}/${params.id}`,params).then((response)=>{
      commit('set_update_floor',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Update Floor Details')
      return false;
    });
  },

  deleteFloor(){},

  //rooms
  getFloorRooms({commit},param){
    return axios.get(`${FLOOR_ROOMS}/${param.id}`).then((response)=>{
      const floor ={
        id : response.data.id,
        code : response.data.code,
        price_rate : response.data.price_rate,
        hotel_id : response.data.hotel_id,
        status : response.data.status,
      }
      commit('set_rooms',response.data.rooms);
      commit('set_floor',floor);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Floor Rooms');
      return false;
    });
  },

 async getFloorsByHotel({commit},params){
    return await axios.post(GET_FLOORS_BY_HOTEL,params).then((response)=>{
      commit('set_floors_by_hotel',response.data);
      return true;
    }).catch((error)=>{
      GlobalUtility.failProgressBar();
      GlobalUtility.generateResponseMessage(error,'Get Floors By hotel.')
      return false;
    });
  },

  setNullFloor({commit}){
    commit('set_null_floor');
  },

  setNullFloors({commit}){
    commit('set_null_floors');
  }

};

const getters = {
  floor : state => state.floor,
  floors : state => state.floors,
  newFloor : state => state.newFloor,

};

export default {state,actions,mutations,getters};